// Pinned conversations + private chat names (2026-10-21) —
// pages/admin/assistant/chat/ChatPrefsControls.tsx. French string → English.
const m: Record<string, string> = {
  'Épingler': 'Pin',
  'Désépingler': 'Unpin',
  'Renommer…': 'Rename…',
  'Épinglée': 'Pinned',
  'Options de la conversation': 'Conversation options',
  'Visible par vous seul': 'Only you can see this',
  'Nom privé (visible par vous seul)': 'Private name (only you see it)',
  'Enregistrer le nom': 'Save name',
  'Annuler': 'Cancel',
  'Fermer': 'Close',
  'Épingle ou nom non enregistré — réessayez.': 'Pin or name not saved — try again.',
  'Conversation épinglée — plus ancienne que la liste': 'Pinned conversation — older than the list',
  // Order chips + ← → between chats (2026-10-30) — chat/OrderChips.tsx, ConversationsTab.tsx.
  'Avance': 'Deposit',
  '{n} commandes — voir les autres': '{n} orders — see the others',
  'Ses autres commandes': 'Her other orders',
  'Une seule commande.': 'Only one order.',
  'Conversation précédente (←)': 'Previous conversation (←)',
  'Conversation suivante (→)': 'Next conversation (→)',
};
export default m;
